import { render, staticRenderFns } from "./SlipDocuments.vue?vue&type=template&id=474311bc&scoped=true&"
import script from "./SlipDocuments.vue?vue&type=script&lang=js&"
export * from "./SlipDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SlipDocuments.vue?vue&type=style&index=0&id=474311bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474311bc",
  null
  
)

export default component.exports